export const replaceSpaceWithDashes = (string) => string.replace(/\s/g, '-');

export const firstLetterInCapitals = (string) => string?.charAt(0).toUpperCase() + string?.slice(1);

export const snakeToCamel = (string) =>
  string.replace(/([-_][a-z])/gi, ($1) => $1.toUpperCase().replace('-', '').replace('_', ''));

export const capitalizeFirstLetter = (string) => string?.[0].toUpperCase().concat(string.slice(1));

export const takeNCharacters = (n) => (text) => text.slice(0, n);

export const dropNCharacters = (n) => (text) => text.slice(n, text.length);

export const dropLastCharacter = (string) => string.slice(0, string.length - 1);

export const getFirstWordFrom = (string) => string.split(' ').find((newString) => newString !== '');
